class Effect {
    constructor() {
        this.active = true;
    }
}
export default Effect;
//# sourceMappingURL=Effect.js.map